<div
  class="multiselect position-relative user-select-none"
  [class.multiselect-disabled]="disabled()"
  [class.chips]="chips()"
>
  <button
    #reference
    type="button"
    class="form-select text-start"
    [class.is-open]="isOpen()"
    [ngClass]="formSelectClasses()"
    [disabled]="disabled()"
    [attr.data-testid]="testId() ? testId() + '_toggle' : undefined"
    [attr.aria-disabled]="disabled() ? 'true' : null"
    (mousedown)="openButtonClick()"
  >
    @if (chips()) {
      @for (option of selectedOptions(); track getValue(option)) {
        <!-- Note this needs to be (mousedown) not (click) so that we can stopPropagation to prevent opening/closing the dropdown -->
        <span
          class="chip"
          [attr.data-testid]="testId() ? testId() + '_chip' + getValue(option) : undefined"
          (mousedown)="setOptionSelected(option, false); $event.stopPropagation()"
        >
          {{getLabel(option)}}
          @if (!disabled()) {
            <i class="far fa-times-circle ms-1"></i>
          }
        </span>
      }
    } @else {
      <div class="d-flex">
        @if (displayLabel().length) {
          <div class="d-grid">
            <span class="selected-items-label">{{ displayLabel() }}&nbsp;</span>
            @if (buttonLabelAutoReplaceWithCount()) {
              <span class="selected-items-fallback-label opacity-0">{{ selectedItemCountLabel() }}</span>
            }
          </div>
        } @else {
          <span class="placeholder-label">{{ placeholder() }}&nbsp;</span>
        }
        @if (multi() && selectedValueArray().length > 0 && showItemCount() && !buttonLabelAutoReplaceWithCount()) {
          <span
            class="badge rounded-pill text-bg-colour-blue-600 align-self-center">{{ selectedItemCountLabel() }}</span>
        }
      </div>
    }
  </button>

  <div
    #dropdown
    class="dropdown lender-list-wider"
    [class.is-open]="isOpen()"
    [class.is-closed]="!isOpen()"
    [style.minHeight]="minHeight() + 'px'"
  >
    @if (showSearch()) {
      <div class="search-pane">
        <div class="input-group input-group-sm">
          <span class="input-group-text"><i class="fas fa-search"></i></span>
          <input
            #searchInput
            type="text"
            class="form-control"
            placeholder="Search..."
            [tabIndex]="isOpen() ? 0 : -1"
            [attr.data-testid]="testId() ? testId() + '_searchInput' : undefined"
            [(ngModel)]="searchTerm"
            (focus)="isSearchFocused.set(true)"
            (blur)="isSearchFocused.set(false); onBlur()"
          />

          @if (searchTerm().length) {
            <button
              class="btn btn-sm btn-outline-secondary"
              type="button"
              tabindex="-1"
              [attr.data-testid]="testId() ? testId() + '_searchClear' : undefined"
              (click)="clearSearchTerm()"
            >
              <i class="fas fa-times-circle"></i>
            </button>
          }
        </div>
      </div>
    }

    @if (isVirtualised()) {
      <div [style.height]="optionsContainerHeight()">
        <cdk-virtual-scroll-viewport
          #virtualScroller
          class="h-100"
          minBufferPx="400"
          maxBufferPx="400"
          tabindex="-1"
          [itemSize]="optionHeight()"
        >
          <ng-container
            *cdkVirtualFor="let option of visibleOptions(); let index = index; trackBy: trackByOptionValue; templateCacheSize: 0"
          >
            <ng-container
              *ngTemplateOutlet="dropdownItemTemplate; context: { $implicit: option, index: index, height: optionHeight() + 'px' }"
            />
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </div>
    } @else {
      @for (option of visibleOptions(); track getValue(option)) {
        <ng-container
          *ngTemplateOutlet="dropdownItemTemplate; context: { $implicit: option, index: $index, height: null }"
        />
      }
    }

    @if (showLoadingSpinner()) {
      <div class="mx-auto mb-2 text-muted">
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
        ></span>
        <span>Loading {{pluralOptionNameActual()}}...</span>
      </div>
    } @else if (visibleOptions().length === 0) {
      <p class="text-center mb-2 text-muted">No {{pluralOptionNameActual()}} found...</p>
    }
  </div>
</div>

<ng-template
  #dropdownItemTemplate
  let-option
  let-index="index"
  let-height="height"
>
  <label
    class="option"
    [class.is-hovered]="focusedOptionIndex() === index"
    [class.is-disabled]="disabled() || !getEnabled(option)"
    [class.is-parent]="isParentOption(option)"
    [class.is-child]="isChildOption(option)"
    [class.pointer-events-none]="isParentOption(option) && groupMode() === selectGroupMode.NoSelectParent"
    [attr.data-optionindex]="index"
    [style.height]="height"
    (mouseenter)="onOptionMouseEnter(index)"
    (mouseleave)="onOptionMouseLeave(index)"
  >
    <input
      class="option-checkbox"
      tabindex="-1"
      [type]="multi() ? 'checkbox' : 'radio'"
      [class.is-collapsed]="!showCheckboxes() || (groupMode() === selectGroupMode.NoSelectParent && isParentOption(option)) || chips()"
      [checked]="isOptionSelected(option)"
      [disabled]="disabled() || !getEnabled(option)"
      [attr.data-testid]="testId() ? testId() + '_item' + getValue(option) : undefined"
      (change)="setOptionSelected(option, $event.target.checked); closeIfSingleSelect()"
    />

    <!-- For single-select, hide the radio button and show a checkmark icon instead -->
    @if (!multi() && showCheckboxes()) {
      <i class="input-icon fas fa-check me-2"></i>
    }

    @if (optionTemplate()) {
      <ng-container
        *ngTemplateOutlet="optionTemplate(); context: { $implicit: option, index: index, isFocused: focusedOptionIndex() === index, isSelected: isOptionSelected(option) }"
      />
    } @else {
      <span class="option-label">{{getLabel(option)}}</span>
    }
  </label>
</ng-template>
